import { render } from "./SessionTimeOut.vue?vue&type=template&id=a8824fbc"
const script = {}

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__